import { render } from "./ReceivedEmailListing.vue?vue&type=template&id=f962886e&scoped=true"
import script from "./ReceivedEmailListing.vue?vue&type=script&lang=js"
export * from "./ReceivedEmailListing.vue?vue&type=script&lang=js"

import "./ReceivedEmailListing.vue?vue&type=style&index=0&id=f962886e&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f962886e"]])

export default __exports__